const firebaseConfig = {
    apiKey: "AIzaSyA2hUzjWsWAGibHFG6Hp8pbrSZ8Hz7OEvw",
    authDomain: "dental-health-care-5f52d.firebaseapp.com",
    projectId: "dental-health-care-5f52d",
    storageBucket: "dental-health-care-5f52d.appspot.com",
    messagingSenderId: "396457260359",
    appId: "1:396457260359:web:3602987d3e32192da6c862"
};

export default firebaseConfig;